module.exports = __webpack_public_path__ + "static/media/chargeads.01bd445f.png";